import React from 'react';
import { Card, Tabs, Typography } from 'antd';
import { ApiOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { DownloadServiceTab } from './tabs/DownloadServiceTab';
import { DirectoryServiceTab } from './tabs/DirectoryServiceTab';

const { TabPane } = Tabs;
const { Title, Text } = Typography;

export const ApiManual: React.FC = () => {
  useTranslation();

  return (
    <Card className="api-manual-page">
      <div className="api-manual-header">
        <Title level={4}>
          <ApiOutlined style={{ marginRight: 8 }} />
          API Manual
        </Title>
        <Text type="secondary">
          Generate code snippets for GET, PUT, and DELETE APIs. Select your
          parameters and copy the generated code.
        </Text>
      </div>

      <Tabs
        defaultActiveKey="download"
        size="large"
        className="api-manual-tabs"
      >
        <TabPane tab="Download Service" key="download">
          <DownloadServiceTab />
        </TabPane>
        <TabPane tab="Directory Service" key="directory">
          <DirectoryServiceTab />
        </TabPane>
      </Tabs>
    </Card>
  );
};

export default ApiManual;
